import { get, put } from './api';
import { User, UserUpdate } from '../types/user';

// Get current user profile
export const getCurrentUser = async (): Promise<User> => {
  return get<User>('/auth/me');
};

// Update user profile
export const updateUserProfile = async (data: UserUpdate): Promise<User> => {
  return put<User>('/auth/me', data);
};
